import React from 'react';

const BlurBlob = ({ position, size }) => {
  const { top, left } = position;
  const { width, height } = size;

  return (
    <div
      className="absolute pointer-events-none"
      style={{
        top: top,
        left: left,
        width: width,
        height: height,
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div className="w-full h-full bg-[#8245ec] rounded-full opacity-15 blur-[120px] animate-pulse"></div>
    </div>
  );
};

export default BlurBlob;